import { TBinaryUpdate } from 'shared/types/domain';

import { arrayBufferToBase64, pngToJpeg } from 'core/helpers/browser';
import { useStableCallback } from 'core/hooks/useStableCallback';

export function useOnPaste(onChange: (update: TBinaryUpdate) => void) {
  return useStableCallback(async function onPaste({
    clipboardData,
  }: React.ClipboardEvent<HTMLInputElement>) {
    const image = Array.from(clipboardData.items).find(i =>
      i.type.startsWith('image/')
    );
    const file =
      image && !image?.type.startsWith('image/svg')
        ? await pngToJpeg(orDie(image.getAsFile()), MAX_WIDTH, MAX_HEIGHT)
        : image?.getAsFile();

    if (file) {
      const mimeType = file.type;
      const data = arrayBufferToBase64(await file.arrayBuffer());
      onChange({
        action: 'set',
        data: `data:${mimeType};base64,${data}`,
      });
    }
  });
}

const MAX_WIDTH = 1000;
const MAX_HEIGHT = 1000;
